const authGuard = (to, from, next) => {
  const accessToken　= sessionStorage.getItem('accessToken')
  if (accessToken) {
    next()
  } else {
    next({name: 'Login'})
  }
}
export default authGuard